
import { StyleColorSchemeType, StyleSizeType, StylePositionType } from '../../styles/enums';
import Dropdown from '../dropdown';
import List from '../list';
import ListItem from '../list-item';
import { SelectEventType, SelectProperty } from './enums';
import SelectOptionsMixin from '../../mixins/select-options';
import StyleClassNamesBuilder from '../../styles/helpers/StyleClassNamesBuilder';
import { searchMatchesElements } from './utils';
import SelectProps from './mixins/SelectProps';

/**
 * Select UI component
 * @deprecated Use ui-kit/components/form/controls/component/select instead
 */
export default {
  name: 'Select',
  components: {
    Dropdown,
    List,
    ListItem,
  },
  mixins: [SelectOptionsMixin, SelectProps],
  data() {
    return {
      listOptions: this.getConvertedOptions(this[SelectProperty.Options]),
      inputValue: this[SelectProperty.Value],
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      SelectProperty,
      SelectEventType,
    };
  },
  computed: {
    wrapperClassNames() {
      return new StyleClassNamesBuilder('select')
        .addClassName(this[SelectProperty.ClassName])
        .build();
    },
    displayValue() {
      if (this[SelectProperty.IsSearch]) {
        return this.inputValue;
      }

      return this.listOptions
        .filter((option) => this.inputValue === option.value)
        .map((option) => option.text)
        .join(', ');
    },
  },
  watch: {
    value(value) {
      this.inputValue = value;
    },
    options(options) {
      this.listOptions = this.getConvertedOptions(options);
    },
  },
  methods: {
    handleOptionClick(value) {
      if (!this[SelectProperty.IsReadonly] && this[SelectProperty.IsSearch]) {
        this.listOptions = this.getConvertedOptions(this.options);
      }
      this.$emit(SelectEventType.Change, value);
    },
    handleClose() {
      this.$emit(SelectEventType.Close, this[SelectProperty.Value]);
    },
    handleDropdownChange(value) {
      if (!this[SelectProperty.IsReadonly] && this[SelectProperty.IsSearch]) {
        this.listOptions = searchMatchesElements(
          this.getConvertedOptions(this[SelectProperty.Options]), value,
        );
        this.inputValue = value;
      }
    },
    handleInputClick(value) {
      this.$emit('inputClick', value);
    },
    isOptionSelected(value) {
      return this.value === value;
    },
  },
};
